import { __decorate } from "tslib";
import { Mixins, Component, Prop } from 'vue-property-decorator';
import PageTitle from '@/components/v2/PageTitle.vue';
import BaseSearchInput from '@/components/v2/BaseSearchInput';
import ApplicationsManager from '@/components/v2/ApplicationsManager.vue';
import ActionButton from '@/components/action_button/Index.vue';
import { startCase } from 'lodash';
import ViewportSizeMixin from '@/helpers/mixins/ViewportSizeMixin';
import ConfirmApplication from '@/components/v2/b2b/ConfirmApplication.vue';
import RejectApplication from '@/components/v2/b2b/RejectApplication.vue';
let ApplicationsByStatus = class ApplicationsByStatus extends Mixins(ViewportSizeMixin) {
    pageTitle(status, count) {
        const formattedStatus = status.replace('_', ' ');
        return `${formattedStatus} Applications ${count}`;
    }
    applicantType(category) {
        return startCase(category);
    }
    get headers() {
        return [
            {
                text: 'APPLICANT NO.',
                value: 'applicantNumber',
                align: 'left',
                sortable: false,
            },
            {
                text: 'APPLICANT TYPE',
                value: 'applicantType',
                align: 'left',
                sortable: false,
            },
            {
                text: 'BRAND',
                value: 'brand',
                align: 'left',
                sortable: false,
            },
            {
                text: 'NAME',
                value: 'name',
                align: 'left',
                sortable: false,
            },
            {
                text: 'DATE AND TIME OF APPLICATION',
                value: 'dateAndTimeOfApplication',
                align: 'left',
                sortable: false,
            },
            {
                text: '',
                value: '',
                align: '',
                sortable: false,
            },
        ];
    }
    viewApplication(applicationUuid) {
        this.$router.push({
            name: 'view-application',
            params: { uuid: applicationUuid },
        });
    }
};
__decorate([
    Prop({ type: String, required: true })
], ApplicationsByStatus.prototype, "status", void 0);
ApplicationsByStatus = __decorate([
    Component({
        components: {
            PageTitle,
            BaseSearchInput,
            ApplicationsManager,
            ActionButton,
            ConfirmApplication,
            RejectApplication,
        },
    })
], ApplicationsByStatus);
export default ApplicationsByStatus;
